import * as Data from "../Data/Data";

export class UserService {

  static serviceId = 'UserService';
  static $inject = ['$proxy', '$q'];


  constructor(private $proxy: Data.ProxyContainer, private $q: ng.IQService) {
  }

  editPassword(user: Data.IUserVm) {
    return this.$proxy.Account.editOwnPassword(user);
  }
}